// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const LANDING_OPTIONS_LAYOUT_SELECTOR_COMPONENT_PROPS = {
  radioButton: true,
  variant: VARIANTS.SelectorRowVariants.CUSTOM,
};

export { LANDING_OPTIONS_LAYOUT_SELECTOR_COMPONENT_PROPS };
